import React, { Suspense } from 'react'
import PageLoader from '../../component/Elements/pageLoader'
import { lazyWithRetry } from '../../helper/lazyWithRetry'

const DiscountsConfig = lazyWithRetry(() => import(/* webpackChunkName: "business-scope-disc" */'../../component/DiscountsConfig'))

const DiscountsConfigPage = React.memo(() => {
	return (
		<Suspense fallback={<PageLoader />}>
			<DiscountsConfig />
		</Suspense>
	)
})

DiscountsConfigPage.displayName = 'DiscountsConfigPage'
export default DiscountsConfigPage
